<template>
  <v-navigation-drawer :value="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
    <v-list dense>
      <template v-for="item in items">
        <v-list-item :key="item.text" :to="item.link">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  props: {
    drawer: {
      required: true,
    },
  },
  data: () => ({
    items: [
      { icon: 'mdi-earth', text: 'Dashboard', link: '/dashboard' },
      { icon: 'mdi-account-group', text: 'Clients', link: '/clients' },
    ],
  }),
};
</script>
